import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useT } from '../../i18n';

// Follows the Contact.js conventions: function component, hooks,
// section > .wrapper > .section_inner.
export default function Login() {
    const { isSignedIn, isChecking, signIn } = useAuth();
    const { t } = useT();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    // Where to land after signing in: whatever RequireAuth was guarding,
    // falling back to the portfolio.
    const from = location.state?.from || '/holdings';

    // The backend redirects here with ?error=... when it turns a sign-in away,
    // e.g. a personal Gmail address. Rendered as-is because those messages are
    // written to be user-facing and never contain internal detail.
    const error = searchParams.get('error');

    if (isChecking) return null;
    if (isSignedIn) return <Navigate to={from} replace />;

    return (
        <section className="auth__sec">
            <div className="wrapper">
                <div className="section_inner">
                    <div className="auth__panel">
                        <h2 className="heading styled">{t('login.title')}</h2>
                        <div className="desc">
                            <p>{t('login.blurb')}</p>
                        </div>

                        {error && (
                            <p className="auth__error" role="alert">
                                {error}
                            </p>
                        )}

                        <button
                            type="button"
                            className="css_btn auth__signin"
                            onClick={() => signIn(from)}
                        >
                            <span>{t('login.signIn')}</span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}
